import z from 'zod';

import { socialApiClient } from '@/shared/api-client/social-api-client';

import { filterConditionsSchema } from '../discovery-schema';

export const searchHistoryResponseSchema = z.object({
  id: z.string(),
  workspace_id: z.string(),
  search_type: z.enum(['prompt', 'lookalike']),
  prompt: z.string().nullable().optional(),
  filters: filterConditionsSchema,
  post_feature_conditions: z.array(z.string()),
  seed_post_ids: z.array(z.string()).nullable().optional(),
  complete: z.boolean(),
  progress_percentage: z.number().int().min(0).max(100),
  total_count: z.number().int(),
  last_search_attempt: z.number().int(),
  created_at: z.string(),
});

export type SearchHistoryResponse = z.infer<typeof searchHistoryResponseSchema>;

export async function getCreatorDiscoverySearchStatus(
  sessionId: string,
  searchId: string,
  signal?: AbortSignal,
): Promise<SearchHistoryResponse> {
  const response = await socialApiClient.get(
    `discovery-sessions/${sessionId}/search/${searchId}/status`,
    {
      signal,
    },
  );

  return await response.json();
}
